import { FormGroup, Typography } from '@mui/material';
import React, { useState } from 'react';
import { FieldValues, UseFormWatch } from 'react-hook-form';

import { WsSelect, WsSelectObj } from '../../../components/WsSelect';
import { WsTypoVariants, WsTypoColors } from '../../WsTypography/WsTypography';
import EditCommonComponent from '../EditCommonComponent';

export interface SelectEditObj {
  label: string;
  value: number | string;
}

export interface SelectEditProps {
  name: string;
  label?: string;
  selectArray: WsSelectObj[];
  defaultValue?: string | null;
  onConfirm: (key: string, value: any) => void;
  textVariant?: WsTypoVariants;
  color?: WsTypoColors;
  onChangeValue?: (val: any) => void;
  watch: UseFormWatch<FieldValues>;
  disabled?: boolean;
}

const SelectEdit = ({
  name,
  textVariant,
  onConfirm,
  defaultValue = null,
  color,
  selectArray,
  watch,
  disabled = false,
}: SelectEditProps) => {
  const [isEdit, setIsEdit] = useState(false);
  const [tempValue, setTempValue] = useState<string | null>(defaultValue);

  const numberData = watch(name);

  const handleConfirm = () => {
    onConfirm(name, watch(name));
    setIsEdit(false);
    setTempValue(numberData);
  };

  const handleClose = () => {
    setIsEdit(false);
  };

  const handleClick = () => {
    if (!disabled) {
      setIsEdit(!isEdit);
    }
  };

  return (
    <>
      {isEdit && !disabled ? (
        <FormGroup>
          <WsSelect
            name={name}
            selectArray={selectArray ?? []}
            placeholder="option"
            defaultValue={defaultValue ?? undefined}
          />
          <EditCommonComponent onClose={handleClose} onConfirm={handleConfirm} />
        </FormGroup>
      ) : (
        <Typography
          variant={textVariant}
          color={color}
          sx={{
            overflow: 'hidden',
            display: 'block',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            cursor: disabled ? 'default' : 'pointer',
            opacity: disabled ? 0.9 : 1,
          }}
          onClick={handleClick}
        >
          {selectArray.find((val) => val.value == tempValue)?.label ?? defaultValue}
        </Typography>
      )}
    </>
  );
};

export default SelectEdit;
